import { createQueryKeys } from '@lukemorales/query-key-factory'

import type { UseQueryOptionsWithoutQueryFn } from '~/types/util/tanstack-query'

import { useFetchContractBuilder } from './useFetchContractBuilder'

export const queryKeys = createQueryKeys('contractBuilder', {
  session: ({
    contractId,
  }: {
    contractId: MaybeRef<string>
  }) => ({ queryKey: [contractId] }),
  guests: ({
    contractId,
  }: {
    contractId: MaybeRef<string>
  }) => ({ queryKey: [contractId] }),
})

const session = ({
  contractId,
  useQueryOptions = {},
}: {
  contractId: MaybeRef<string>
  useQueryOptions?: UseQueryOptionsWithoutQueryFn
}) => {
  const { join } = useFetchContractBuilder()
  const { activeWorkspaceId } = useAuth()

  return useQuery({
    ...queryKeys.session({
      contractId,
    }),
    queryFn: () => join({
      contractId: unref(contractId),
      workspaceId: unref(activeWorkspaceId) || '',
    }),
    enabled: () => !!unref(activeWorkspaceId),
    ...useQueryOptions,
  })
}

const getGuests = ({
  contractId,
  useQueryOptions = {},
}: {
  contractId: MaybeRef<string>
  useQueryOptions?: UseQueryOptionsWithoutQueryFn
}) => {
  const { getGuests: _getGuests } = useFetchContractBuilder()
  const { activeWorkspaceId } = useAuth()

  return useQuery({
    ...queryKeys.guests({ contractId }),
    queryFn: () => _getGuests({ contractId: unref(contractId), workspaceId: unref(activeWorkspaceId) || '' }),
    enabled: () => !!unref(activeWorkspaceId),
    ...useQueryOptions,
  })
}

export const useQueryContractBuilder = {
  session,
  getGuests,
}
